<template>
    <div>
     <table class="tableData" >
        <thead>
            <tr class="header-row">
                <th :class="colum.lable == 'Log Message Particles'? 'LogMessageParticles': 'columnHeading'" 
                v-for="(colum,index) in columnData " :key="index">{{ colum.lable }}</th>
            </tr>
        </thead>
        <tbody>
            <tr  class="tableData-row" v-for="(record,index) in tableDataRecord " :key="index" >
                <td v-for="(colum,index) in columnData " :key="index" >
                    <slot :value="{'record': record, 'column': colum, 'index':index}">
                    </slot>
                </td>
            </tr>
        </tbody>
     </table>
    </div>
</template>
<script>
export default{
    props:{
      columnData:Array,
      tableDataRecord:Array
    },
    data(){
        return{

        }
    }
}
</script>
<style lang="scss" scoped>
.LogMessageParticles{
    width:880px
}

.columnHeading{
   width: 200px;
}
.tableData{
        width: 100%;
        border-collapse: collapse;
        margin: 0 auto;
        font-family: Montserrat;
        margin-bottom: 4px;
}
.header-row {
            background-color: white;
            height: 54px;
            th {
                background-color: #f0f1f5;
                border-bottom: 1px solid #34c0be;
                padding: 6px 30px;
            }
        }
.tableData-row:hover{
   &:nth-child(odd){
    background-color: #d9f4f3;
   }
}
.tableData-row{
    height: 8px;
    background-color: white;
         &:nth-child(even){
            background-color: #f0f1f5;
         }
         td{
            padding: 6px 30px;
         }
}
</style>